import { Injectable } from '@angular/core';
import { of } from 'rxjs';

@Injectable()
export class DeliveryOverviewResolver {
  resolve() {
    return of(true);
  }
}
